import moment, { Moment, MomentInput } from 'moment';

export function toMoment(date: MomentInput): Moment {
  return moment.isMoment(date) ? date : moment(date);
}
